import { render } from "./CommonLoader.vue?vue&type=template&id=45f8dba7"
import script from "./CommonLoader.vue?vue&type=script&lang=js"
export * from "./CommonLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__